import "./signup.css";
import {
  React,
  Link,
  useNavigate,
  useRef,
  useEffect,
  Button,
  DigitalSignage,
  toast,
  useState,
  LoadingSpinner,
  Password,
  InputText,
  captureeventbaseanalytics,
  capturepageanalytics,
  Divider,
  useCheckUserNameAvailabilityMutation,
  useGoogleLogin,
  axios,
  BASEURL,
  RemoveCookie,
  SetCookie,
  GoogleIcon,
  Avatar,
} from "../../../Libraries/Authentication/SignUp/index";
import { Typography } from "@mui/material";
import { debounce } from "lodash";
import { useCallback } from "react";
import BoostBoardLogo from '../../../Assets/svgs/boostboard_logo.svg';

const Signup = () => {
  const [loading, setloading] = useState(false);
  const [checkUsername, { isLoading }] = useCheckUserNameAvailabilityMutation();
  const navigate = useNavigate(null);
  const [message, setmessage] = useState(null);
  const [isError, setisError] = useState(false);
  const email = useRef(null);
  const phone = useRef(null); // New ref for phone number

  const [inputdata, setinputdata] = useState({
    password: "",
    username: "",
    phone: "", // New state for phone number

  });

  const header = <h6>Pick a password</h6>;
  const footer = (
    <React.Fragment>
      <Divider />
      <p className="mt-2">Suggestions</p>
      <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: "1.5" }}>
        <li>At least one special character</li>
        <li>At least one uppercase</li>
        <li>At least one lowercase</li>
        <li>At least one numeric</li>
        <li>Minimum 8 characters</li>
      </ul>
    </React.Fragment>
  );

  // google analytics page visit
  useEffect(() => {
    capturepageanalytics(window.location.pathname);
  }, []);

  // password regex operation
  const PasswordRegex = () => {
    var re = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,20}$"
    );
    return re.test(inputdata.password);
  };
 // Phone number validation regex
 const PhoneRegex = (phone) => {
  const re =/^03\d{9}$/; // This will validate a 10-digit phone number
  return re.test(phone);
};
const handlePhoneChange = (e) => {
  const value = e.target.value;

  // Allow only digits and prevent input longer than 11 characters
  const numericValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
  if (numericValue.length <= 11) {
    setinputdata({ ...inputdata, phone: numericValue });
  }
};
  // get OTP functionality (2)
  const GetOTP = () => {
    try {
      const getotpdata = new FormData();
      getotpdata.append("txt_customer_id", inputdata.username);
      getotpdata.append("txt_customer_email", email.current.value);
      getotpdata.append("txt_customer_phone_number", phone.current.value); //Added for API Shifting
      getotpdata.append("function", "GET_OTP");

      const otprequestoption = {
        method: "POST",
        body: getotpdata,
        cache: "no-cache",
        referrerPolicy: "no-referrer",
      };

      fetch(BASEURL + "customer/signage.php", otprequestoption)
        .then(function (response) {
          if (response.status !== 200) {
            setloading(false);
            toast.error(response.status);
            console.log("Error", response);
          } else {
            response.json().then(function (data) {
              if (
                data.connection === "true" &&
                data.status === "true" &&
                data.message === "OTP has been sent via SMS and mail"
              ) {
                // toast.success(data.message);  //// Removed in API Shifting (03-07-2025)
                captureeventbaseanalytics(
                  "Authentication",
                  "BoostBoard_Signup",
                  data.message
                );
                setTimeout(() => {
                  setloading(false);
                  navigate(
                    "/authverification",
                    {
                      state: {
                        userid: inputdata.username,
                        email: email.current.value,
                        password: inputdata.password,
                        phone: phone.current.value,   //added by maheen for api shifting
                      },
                    },
                    3000
                  );
                });
              } else {
                setloading(false);
                toast.error(data.message);
                captureeventbaseanalytics(
                  "Authentication",
                  "BoostBoard_Signup",
                  data.message
                );
              }
            });
          }
        })
        .catch((error) => {
          setloading(false);
          toast.error(error.message);
          console.error(error);
          captureeventbaseanalytics("Customer Creation", "GetOTP", error);
        });
    } catch (error) {
      console.log(error);
      setloading(false);
      toast.error(error.error);
    }
  };

  // field level validation (1)
  const formvalidations = (e) => {
    e.preventDefault();

    if (inputdata.username === "") {
      toast.error("username is empty");
      captureeventbaseanalytics(
        "Customer Creation",
        "Click",
        "username is empty"
      );
    } else if (email.current.value === "") {
      toast.error("email is empty");
      email.current.focus();
      captureeventbaseanalytics("Customer Creation", "Click", "email is empty");
    } 
    else if (inputdata.phone === "") {
      toast.error("Phone number is empty");
      phone.current.focus();
      captureeventbaseanalytics("Customer Creation", "Click", "phone is empty");
    } 
     else if (!PhoneRegex(inputdata.phone)) {
      toast.error("Please enter a valid 11-digit phone number");
      captureeventbaseanalytics("Customer Creation", "Click", "Invalid phone number format");
    } 
    else if (inputdata.password === "") {
      toast.error("password is empty");
      captureeventbaseanalytics(
        "Customer Creation",
        "Click",
        "password is empty"
      );
    } else if (
      inputdata.password.length < 8 ||
      inputdata.password.length > 20
    ) {
      toast.error("please add the password between 8-20 characters");
      captureeventbaseanalytics(
        "Customer Creation",
        "Click",
        "please add the password between 8-20 characters"
      );
    } else if (!PasswordRegex(inputdata.password)) {
      toast.error("Please add the proper password format");
      captureeventbaseanalytics(
        "Customer Creation",
        "Click",
        "Please add the proper password format"
      );
    } else {
      setloading(true);
      GetOTP();
      captureeventbaseanalytics("Customer Creation", "GetOTP", "GetOTP");
    }
  };

  // checking username availability functionality
  const handleChangeUsername = async (e) => {
    setinputdata({
      ...inputdata,
      [e.target.name]: e.target.value,
    });
    if (e.target.value?.length >= 6) {
      //added by haseeb
  const specialCharRegex = /[A-Z\\'"^�$%&*()}{@#~?><>,.|=+�-]/;
if (specialCharRegex.test(e.target.value)) {
  setisError(true);
  setmessage("Uppercase and special characters are not allowed in userid.");
  return;


  }

  try {
    const payload = new FormData();
    payload.append("txt_customer_id", e.target.value);
    const res = await checkUsername(payload).unwrap();
    if (
      res.connection === "true" &&
      res.status === "true" &&
      res.message === "Result available"
    ) {
      if (
        res.data.responsetype === "success" &&
        res.data.message === "UserId is Available." &&
        res.data.data.length === 0
      ) {
        setisError(false);
        setmessage(res.data.message);
      } else {
        setisError(true);
        setmessage(res.data.message);
      }
    } else {
      toast.error(res.message);
    }
  } catch (error) {
    console.error(error);
    toast.error(error.error);
  }
}

  };

  const handleTextDebounce = useCallback(
    debounce(handleChangeUsername, 1200),
    []
  );

  // onchange listner for username field
  const handleInputChangeField = (e) => {
    setinputdata({
      ...inputdata,
      [e.target.name]: e.target.value,
    });
  };

  // customer creation via google (3rd step)
  const CreateCustomerViaGoogle = (userinfo, access_token) => {
    try {
      setloading(true);
      // api call to create customer at es end
      const createCustomer = new FormData();
      createCustomer.append("txt_customer_email", userinfo.email);
      createCustomer.append("gmail_sub", userinfo.sub);
      createCustomer.append("gmail_access_token", access_token);
      createCustomer.append("function", "SIGNUP_WITH_GOOGLE");

      const createcustomerrequestoption = {
        method: "POST",
        body: createCustomer,
        cache: "no-cache",
        referrerPolicy: "no-referrer",
      };

      fetch(BASEURL + "customer/signage.php", createcustomerrequestoption)
        .then(function (response) {
          if (response.status !== 200) {
            setloading(false);
            toast.error(response.Error);
            console.error("Error", response);
          } else {
            response.json().then(function (data) {
              if (
                data.status === "true" &&
                data.message === "Login Success" &&
                data.connection === "true"
              ) {
                setloading(false);
                toast.success(data.message);
                captureeventbaseanalytics(
                  "Customer Creation Via Google",
                  "customer/signage.php RESPONSE",
                  data.message
                );
                RemoveCookie("es_token");
                SetCookie("es_token", data.data.es_token);
                localStorage.setItem("txt_customer_id", data.data.USERID);
                navigate("/dashboard");
              } else {
                setloading(false);
                toast.error(data.message);
                captureeventbaseanalytics(
                  "Customer Creation Via Google",
                  "customer/signage.php RESPONSE",
                  data.message
                );
                console.log(data);
              }
            });
          }
        })
        .catch((error) => {
          setloading(false);
          toast(error.status);
          console.error(error);
          captureeventbaseanalytics(
            "Customer Creation",
            "customer/signUpCustomerWithGmail.php RESPONSE",
            error.message
          );
        });
    } catch (error) {
      toast.error(error.status);
      console.error(error);
      setloading(false);
    }
  };

  // customer creation via google (2nd step)
  const CreationUserFromGoogle = async (res) => {
    const userInfo = await axios
      .get("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: { Authorization: `Bearer ${res.access_token}` },
      })
      .then((res) => res.data);
    if (userInfo.email_verified === true && userInfo.email !== "") {
      CreateCustomerViaGoogle(userInfo, res.access_token);
    }
  };

  const onFailure = (err) => {
    console.error("error:", err);
  };

  // customer creation via google (1st step)
  const SignupViaGoogle = useGoogleLogin({
    onSuccess: CreationUserFromGoogle,
    onError: (error) => onFailure(error),
  });

  return (
    <>
      {loading ? <LoadingSpinner /> : null}
      <div
        className="bg_sp"
        style={{
          backgroundImage: `url(${"https://bbapi.nayatel.com/api/api/web/AuthBackgroundImage/authbg.png"}), url(${require("../../../Assets/Images/authbg.png")})`,
        }}
      >
        <div className="card_wrapper_sp">
          <div className="shadow rowdesign_su">
            <div className="auth_logo_signup">
              <img src={BoostBoardLogo} alt="logo" width="170px" />
            </div>
            <form className="signupform" onSubmit={formvalidations}>
              <div className="row  inputfields">
                <div className="col-md-12 col-lg-12 col-sm-12 label_login">
                  <label className="label_login">Username</label>
                  <InputText
                    autoComplete="off"
                    placeholder="Username"
                    className={`p-inputtext-sm block mb-1 w-100 ${
                      isError && inputdata?.username?.length > 6
                        ? "p-invalid"
                        : ""
                    }`}
                    name="username"
                    onChange={handleTextDebounce}
                  />
                </div>
                {inputdata?.username?.length > 6 ? (
                  <Typography
                    color={isError ? "red" : "green"}
                    fontSize="0.8rem"
                  >
                    {isLoading ? "Checking..." : message}
                  </Typography>
                ) : null}
                <div className="col-md-12 col-lg-12 col-sm-12 label_login mt-1">
                  <label className="label_login">Email</label>
                  <InputText
                    autoComplete="off"
                    placeholder="Email"
                    className="p-inputtext-sm block mb-1 w-100"
                    ref={email}
                  />
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 label_login mt-1">
                  <label className="label_login">Phone Number</label>
                  <InputText
                    autoComplete="off"
                    placeholder="Phone"
                    className="p-inputtext-sm block mb-1 w-100"
                    ref={phone} // Assign the ref to the phone number field
                    value={inputdata.phone}
                    onChange={handlePhoneChange} // Handle phone input
                  />
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 label_login mt-1">
                  <label className="label_login">Password</label>
                  <Password
                    className="p-inputtext-sm block w-100"
                    placeholder="Password"
                    autoComplete="off"
                    feedback={true}
                    name="password"
                    onChange={handleInputChangeField}
                    header={header}
                    footer={footer}
                    toggleMask
                  />
                </div>
              </div>
              <div className="form-group">
                <Button
                  sx={{
                    width: "100%",
                    marginTop: "15px",
                  }}
                  className="capitalized fs-14 fw-bold"
                  variant="contained"
                  type="submit"
                >
                  Signup
                </Button>
              </div>
            </form>

            <div className="signup">
              <div className="or-container">
                <div className="line-separator"></div>{" "}
                <div className="or-label">OR</div>
                <div className="line-separator"></div>
              </div>
            </div>

            <Button
              onClick={SignupViaGoogle}
              startIcon={
                <Avatar
                  src={GoogleIcon}
                  sx={{ width: "15px", height: "15px" }}
                />
              }
              variant="outlined"
              sx={{
                width: "100%",
                textTransform: "none",
              }}
            >
              Continue with Google
            </Button>

            <div className="signuptologin">
              <span className="alreadyhaveanacc">
                Already have an account? &nbsp;
              </span>

              <Link
                to="/login"
                style={{ fontWeight: "bold", color: "#1A75E8" }}
              >
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
